export default __webpack_public_path__ + "static/media/icon-care-admin-patient-plan-history-new.f1449f4f.svg";